import { MjmlColumn, MjmlRaw, MjmlSection, MjmlText } from "@faire/mjml-react";
import { Fragment } from "react";

import type { SurveyAnswersNode } from "../../nodes/survey-answers/survey-answers-node";

export function $transformSurveyAnswersNode(node: SurveyAnswersNode): React.JSX.Element {
  const qFontWeight = node.getQuestionBold() ? "bold" : "normal";
  const qFontStyle = node.getQuestionItalic() ? "italic" : "normal";
  const qTextDecoration = node.getQuestionUnderline() ? "underline" : "none";
  const qColor = node.getQuestionColor();
  const aFontWeight = node.getAnswerBold() ? "bold" : "normal";
  const aFontStyle = node.getAnswerItalic() ? "italic" : "normal";
  const aTextDecoration = node.getAnswerUnderline() ? "underline" : "none";
  const aColor = node.getAnswerColor();
  const key = "survey-answers";

  return (
    <Fragment key={key}>
      <MjmlRaw
        key={`${key}-each-open`}
        dangerouslySetInnerHTML={{ __html: `{{#each survey_result_${node.getSurveyId()}}}` }}
      />
      <MjmlSection mjmlClass="section" padding-bottom="24px" key={`${key}-section`}>
        <MjmlColumn>
          <MjmlText
            padding-top="0"
            padding-bottom="8px"
            fontWeight={qFontWeight}
            fontStyle={qFontStyle}
            textDecoration={qTextDecoration}
            color={qColor}
          >
            {"{{this.question}}"}
          </MjmlText>
          <MjmlText
            padding-top="0"
            padding-bottom="0"
            fontWeight={aFontWeight}
            fontStyle={aFontStyle}
            textDecoration={aTextDecoration}
            color={aColor}
          >
            {"{{this.answer}}"}
          </MjmlText>
        </MjmlColumn>
      </MjmlSection>
      <MjmlRaw key={`${key}-each-close`} dangerouslySetInnerHTML={{ __html: "{{/each}}" }} />
    </Fragment>
  );
}
